import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article';
  author?: string;
}

export default function SEO({
  title = 'Luciano Argolo - Data Engineering Hub',
  description = 'Aprende Data Engineering con proyectos reales. Cursos, mentoría y comunidad para convertirte en Data Engineer profesional.',
  keywords = 'data engineering, big data, python, sql, databricks, spark, airflow, aws',
  image = 'https://lucianoargolo.com/og-image.jpg',
  url = 'https://lucianoargolo.com',
  type = 'website',
  author = 'Luciano Argolo',
}: SEOProps) {
  const fullTitle = title.includes('Luciano Argolo') ? title : `${title} | Luciano Argolo`;
  const siteUrl = url.startsWith('http') ? url : `https://lucianoargolo.com${url}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={siteUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Luciano Argolo" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@Dataengine35280" />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
}

